<template>
  <v-expansion-panel
    class="tasklist-expander mb-3 p-relative withRemove elevation-0 parent-expansion on-white-bg rounded-3"
    :ref="`expansionPanel-${emailAccount.id || index}`">
    <div class="horiz-left-coloured-bg info--gradient">
      <v-icon color="white" class="mt-0 horiz-left-coloured-bg--icon">email</v-icon>
    </div>
    <v-expansion-panel-content class="rounded-3">
      <div slot="header">
        <h3 class="text-truncate py-1 ml-4  horiz-left-coloured-bg--padding-header">
          {{ emailAccount.name }}
          <v-icon v-if="emailAccount.hasMessage" color="error" small class="ml-2"
            title="Server message available">warning</v-icon>
        </h3>
        <v-flex xs12 class=" ml-4 horiz-left-coloured-bg--padding-header">
          <span class="mr-1 opacity-54" style="display:inline-block;">Description:</span>
          <span class="d-inline-block mr-3">{{ emailAccount.description }}</span>
        </v-flex>
        <v-btn class="remove-account-btn" @click.stop="showDeleteDialog()"
          style="position:absolute; z-index:9; right:0; top:11px" icon>
          <v-icon color="error">cancel</v-icon>
        </v-btn>
      </div>
      <v-layout class="horiz-left-coloured-bg--padding">
        <v-flex pr-4 pl-4 pb-4 pt-0>
          <!-- Server Message Alert -->
          <v-flex xs12 v-if="emailAccount.hasMessage && emailAccount.serverMessage" class="mt-3 mb-3">
            <v-alert :value="true" type="error" icon="warning" dismissible class="mb-0">
              <div class="font-weight-bold mb-2">Server Message</div>
              <div class="server-message-content">{{ formattedServerMessage }}</div>
            </v-alert>
          </v-flex>
          <v-flex xs12 sm6
            :class="{ 'mt-3 pr-0 pb-4 ': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp }">
            <v-text-field label="Name" box v-model="emailAccount.name" v-on:change="dirty()"
              :rules="[rules.required]"></v-text-field>
            <v-text-field value="Connects to our support account" label="Description" box
              v-model="emailAccount.description" v-on:change="dirty()"></v-text-field>
            <v-checkbox v-if="showDefaultCheckbox" color="secondary" label="Is Default Account for Outbound Email"
              v-model="emailAccount.isDefault" class="ma-0" v-on:change="dirty()"></v-checkbox>
          </v-flex>
          <div class="config-card-container">
            <v-card class="pa-4 config-card">
              <div class="mb-3">
                <h3 class="mb-0">Receiving Email</h3>
              </div>
              <v-select :items="receiveChannelOptions" label="Receive Email Via" box v-model="receiveChannel"
                v-on:change="onReceiveChannelChange()" :rules="[rules.required]" :disabled="!canEditChannels"
                class="mt-2"></v-select>

              <div v-if="receiveChannel === 'ImapConnector'" class="mt-4">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pr-sm-3 pb-3">
                    <v-text-field label="Host" value="imap.gmail.com" box v-model="emailAccount.imapDetails.host"
                      v-on:change="dirty()" :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-3 pb-3">
                    <v-text-field style="max-width:100px" label="Port" value="993" box
                      v-model.number="emailAccount.imapDetails.port" v-on:change="dirty()"
                      :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pb-3">
                    <v-text-field label="Login" value="support@emergeadapt.com" box
                      v-model="emailAccount.imapDetails.login" v-on:change="dirty()"
                      :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pb-3">
                    <v-text-field type="password" label="Password" value="wqfasds" box
                      v-model="emailAccount.imapDetails.password" v-on:change="dirty()"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs12 sm4>
                        <v-checkbox color="secondary" label="Enabled" class="ma-0"
                          v-model="emailAccount.imapDetails.enabled" v-on:change="dirty()"></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-checkbox color="secondary" class="ma-0" label="SSL" v-model="emailAccount.imapDetails.ssl"
                          v-on:change="dirty()"></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-checkbox color="secondary" label="Start TLS" class="ma-0 mb-4"
                          v-model="emailAccount.imapDetails.startTLS" v-on:change="dirty()"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>

              <div v-if="receiveChannel === 'Office365Connector'" class="mt-4">
                <div v-if="isOffice365ReceiveConnected" class="mb-3">
                  <v-alert :value="true" type="success" class="mb-2">
                    <strong>Connected</strong> - Office 365 is configured and ready to receive emails.
                    <div v-if="office365ReceiveEmailAddress" class="mt-2">
                      <strong>Email:</strong> {{ office365ReceiveEmailAddress }}
                    </div>
                  </v-alert>
                  <div class="text-xs-right">
                    <a :href="office365ReceiveRoute" target="_blank" class="text-link" style="color: #666; font-size: 14px; font-weight: 400;">
                      Reconnect
                    </a>
                  </div>
                </div>
                <div v-else>
                <v-alert :value="true" type="info" class="mb-3">
                    Office 365 uses Microsoft OAuth authentication. Click the button below to select and authenticate with your Microsoft account.
                </v-alert>
                <v-btn 
                  color="primary" 
                  :href="office365ReceiveRoute" 
                  target="_blank" 
                  class="mb-4"
                  :disabled="!canConnectOffice365Receive"
                >
                  Connect to Microsoft Office 365
                </v-btn>
                </div>
              </div>
            </v-card>
            <v-card class="pa-4 config-card">
              <div class="mb-3">
                <h3 class="mb-0">Sending Email</h3>
              </div>
              <v-select :items="sendChannelOptions" label="Send Email Via" box v-model="sendChannel"
                v-on:change="onSendChannelChange()" :rules="[rules.required]" :disabled="!canEditChannels"
                class="mt-2"></v-select>

              <div v-if="sendChannel === 'SmtpConnector'" class="mt-4">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pr-sm-3 pb-3">
                    <v-text-field label="Host" value="smtp.gmail.com" box v-model="emailAccount.smtpDetails.host"
                      v-on:change="dirty()" :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-3 pb-3">
                    <v-text-field style="max-width:100px" label="Port" value="587" box
                      v-model.number="emailAccount.smtpDetails.port" v-on:change="dirty()"
                      :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pb-3">
                    <v-text-field label="Login" value="support@emergeadapt.com" box
                      v-model="emailAccount.smtpDetails.login" v-on:change="dirty()"
                      :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pb-3">
                    <v-text-field type="password" label="Password" value="wqfasds" box
                      v-model="emailAccount.smtpDetails.password" v-on:change="dirty()"></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pb-3">
                    <v-text-field label="Reply to email address" value="support@emergeadapt.com"
                      v-model="emailAccount.smtpDetails.replyToEmailAddress" :rules="[rules.email, rules.required]"
                      v-on:change="dirty()" box></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pb-3">
                    <v-checkbox color="secondary" label="Use reply-to address as from address" 
                      v-model="emailAccount.smtpDetails.useReplyToAsFrom"
                      v-on:change="dirty()" 
                      class="ma-0"
                      hint="When enabled, emails will be sent from the reply-to address instead of the login email">
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs12 sm4>
                        <v-checkbox color="secondary" label="Enabled" v-model="emailAccount.smtpDetails.enabled"
                          class="ma-0" v-on:change="dirty()"></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-checkbox color="secondary" class="ma-0" label="SSL" v-model="emailAccount.smtpDetails.ssl"
                          v-on:change="dirty()"></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-checkbox color="secondary" label="Start TLS" class="ma-0"
                          v-model="emailAccount.smtpDetails.startTLS" v-on:change="dirty()"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>

              <div v-if="sendChannel === 'Office365Connector'" class="mt-4">
                <div v-if="isOffice365SendConnected" class="mb-3">
                  <v-alert :value="true" type="success" class="mb-2">
                    <strong>Connected</strong> - Office 365 is configured and ready to send emails.
                    <div v-if="office365SendEmailAddress" class="mt-2">
                      <strong>Email:</strong> {{ office365SendEmailAddress }}
                    </div>
                  </v-alert>
                  <div class="text-xs-right">
                    <a :href="office365SendRoute" target="_blank" class="text-link" style="color: #666; font-size: 14px; font-weight: 400;">
                      Reconnect
                    </a>
                  </div>
                </div>
                <div v-else>
                <v-alert :value="true" type="info" class="mb-3">
                    Office 365 uses Microsoft OAuth authentication for sending emails. Click the button below to select and authenticate with your Microsoft account.
                </v-alert>
                <v-btn 
                  color="primary" 
                  :href="office365SendRoute" 
                  target="_blank" 
                  class="mb-4"
                  :disabled="!canConnectOffice365Send"
                >
                  Connect to Microsoft Office 365
                </v-btn>
                </div>
                <v-text-field label="Reply to email address" value="support@emergeadapt.com"
                  v-model="emailAccount.smtpDetails.replyToEmailAddress" :rules="[rules.email]" v-on:change="dirty()"
                  box></v-text-field>
                <v-checkbox color="secondary" label="Use reply-to address as from address" 
                  v-model="emailAccount.smtpDetails.useReplyToAsFrom"
                  v-on:change="dirty()" 
                  class="ma-0"
                  hint="When enabled, emails will be sent from the reply-to address instead of the authenticated email">
                </v-checkbox>
              </div>

              <div v-if="isCaseblocksSend" class="mt-4 caseblocks-domain-wrapper">
                <v-card outlined class="pa-4">
                  <div class="d-flex align-center flex-wrap mb-3">
                    <div>
                      <h3 class="mb-1">Caseblocks Domain Configuration</h3>
                      <p class="mb-0">
                        Caseblocks provisions Mailgun to send and receive on your behalf. Configure a domain and keep these DNS records up to date.
                      </p>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      color="success"
                      class="ml-2"
                      :loading="mailgunActionLoading && mailgunActionType === 'configure'"
                      :disabled="configureDomainDisabled"
                      @click="configureMailgunDomain"
                    >
                      Configure domain
                    </v-btn>
                    <v-btn
                      small
                      color="secondary"
                      class="ml-2"
                      :loading="mailgunActionLoading && mailgunActionType === 'refresh'"
                      :disabled="recheckDisabled"
                      @click="refreshCaseblocksStatus"
                    >
                      Re-check status
                    </v-btn>
                  </div>

                  <v-alert v-if="!canInvokeMailgunMutation" type="info" class="mb-3">
                    Save this email setup before configuring the Caseblocks domain.
                  </v-alert>

                  <v-layout wrap>
                    <v-flex xs12 md6 class="pr-md-2 pb-3">
                      <v-text-field
                        label="Domain"
                        v-model="mailgunDomainInput"
                        :disabled="!canInvokeMailgunMutation || mailgunActionLoading"
                        :rules="[rules.required]"
                        hint="Enter the root domain you want Caseblocks to manage (e.g. example.com)."
                        persistent-hint
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 class="pl-md-2 pb-3">
                      <v-text-field label="Status" :value="mailgunDomainStateLabel" box readonly></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-alert v-if="shouldShowCaseblocksWarning && hasMailgunDomain" :value="true" type="warning" class="mb-3">
                    DNS updates are still pending. Mail will flow once the records verify.
                  </v-alert>

                  <v-layout wrap>
                    <v-flex xs12 md6 class="pr-md-2">
                      <h4 class="subtitle-1 font-weight-medium mb-2">Outgoing DNS Records</h4>
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th class="text-left">Type</th>
                            <th class="text-left">Name</th>
                            <th class="text-left">Value</th>
                            <th class="text-left">Priority</th>
                            <th class="text-left">Valid</th>
                            <th class="text-left">Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!sendingDnsRecords.length">
                            <td colspan="6" class="text-xs-center">
                              No sending DNS records available yet. Configure the domain and re-check status.
                            </td>
                          </tr>
                          <tr v-for="record in sendingDnsRecords" :key="record.key">
                            <td>{{ record.type }}</td>
                            <td>
                              <span :title="record.name">{{ record.name }}</span>
                            </td>
                            <td>
                              <span :title="record.value">{{ record.value }}</span>
                            </td>
                            <td>{{ record.priority }}</td>
                            <td>
                              <v-icon small :color="record.valid ? 'success' : 'error'">
                                {{ record.valid ? 'check_circle' : 'cancel' }}
                              </v-icon>
                            </td>
                            <td>{{ record.description || 'Sending' }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-flex>
                    <v-flex xs12 md6 class="pl-md-2 mt-4 mt-md-0">
                      <h4 class="subtitle-1 font-weight-medium mb-2">Incoming DNS Records</h4>
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th class="text-left">Type</th>
                            <th class="text-left">Name</th>
                            <th class="text-left">Value</th>
                            <th class="text-left">Priority</th>
                            <th class="text-left">Valid</th>
                            <th class="text-left">Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!receivingDnsRecords.length">
                            <td colspan="6" class="text-xs-center">
                              No receiving DNS records available yet. Configure the domain and re-check status.
                            </td>
                          </tr>
                          <tr v-for="record in receivingDnsRecords" :key="record.key">
                            <td>{{ record.type }}</td>
                            <td>
                              <span :title="record.name">{{ record.name }}</span>
                            </td>
                            <td>
                              <span :title="record.value">{{ record.value }}</span>
                            </td>
                            <td>{{ record.priority }}</td>
                            <td>
                              <v-icon small :color="record.valid ? 'success' : 'error'">
                                {{ record.valid ? 'check_circle' : 'cancel' }}
                              </v-icon>
                            </td>
                            <td>{{ record.description || 'Receiving' }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-flex>
                  </v-layout>
                </v-card>
              </div>

            </v-card>
          </div>
          <v-flex xs12>
            <delete-dialog :isOpen="deleteDialog" itemType="email setup"
              v-on:delete-item="deleteEmailAccount"></delete-dialog>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import DeleteDialog from "@/components/shared/deleteDialog"
import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export default {
  name: "EmailAccount",
  components: { DeleteDialog },
  props: {
    emailAccount: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  data: () => ({
    isDirty: false,
    deleteDialog: false,
    mailgunDomainInput: "",
    mailgunActionLoading: false,
    mailgunActionType: null,
    emailAccountSubscription: null,
    office365ReceiveEmailAddress: "",
    office365SendEmailAddress: "",
    isExpanded: false,
    rules: {
      required: value => !!value || "Required.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || "Invalid e-mail."
      }
    }
  }),
  created() {
    this.resetMailgunDomainInput(false)
    this.initializeOffice365Email()
  },
  mounted() {
    this.subscribeToEmailAccountUpdates()
  },
  beforeDestroy() {
    this.unsubscribeFromEmailAccountUpdates()
  },
  watch: {
    emailAccount() {
      this.resetMailgunDomainInput(false)
      this.initializeOffice365Email()
    },
    'emailAccount.mailgunDomain'() {
      this.resetMailgunDomainInput(true)
    },
    'emailAccount.smtpDetails.replyToEmailAddress'() {
      if (!this.emailAccount.mailgunDomain) {
        this.resetMailgunDomainInput(false)
      }
    },
    'emailAccount.meta.office365'() {
      this.initializeOffice365Email()
    }
  },
  computed: {
    caseblocksConnectorValue() {
      return "MailgunConnector"
    },
    connectorAliases() {
      return [this.caseblocksConnectorValue, "CaseblocksConnector"]
    },
    canEditChannels() {
      if (typeof this.emailAccount.canEditChannels === "boolean") {
        return this.emailAccount.canEditChannels
      }
      if (typeof this.emailAccount.canUpdate === "boolean") {
        return this.emailAccount.canUpdate
      }
      if (this.emailAccount.permissions && typeof this.emailAccount.permissions.canEditChannels === "boolean") {
        return this.emailAccount.permissions.canEditChannels
      }
      return true
    },
    hasCaseblocksMetadata() {
      return !!(this.emailAccount.mailgunDomain || (this.emailAccount.mailgunDnsRecords && (this.emailAccount.mailgunDnsRecords.sending || this.emailAccount.mailgunDnsRecords.receiving)))
    },
    emailAccountsCount() {
      const accounts = this.$store && this.$store.state && this.$store.state.currentUser && this.$store.state.currentUser.account && this.$store.state.currentUser.account.emailAccounts
      return Array.isArray(accounts) ? accounts.length : 1
    },
    showDefaultCheckbox() {
      return this.emailAccountsCount > 1
    },
    officeIndexRoute() {
      // For new accounts without an ID, use 0 or handle gracefully
      const accountId = this.emailAccount.id || 0
      const officeIndexRoute = `/office365/${accountId}?token=${window.localStorage.session}`
      const route = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${officeIndexRoute}` : officeIndexRoute
      return route
    },
    office365ReceiveRoute() {
      // Route for Office365 receive connection
      const accountId = this.emailAccount.id || 0
      const officeIndexRoute = `/office365/${accountId}?token=${window.localStorage.session}&type=receive`
      const route = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${officeIndexRoute}` : officeIndexRoute
      return route
    },
    office365SendRoute() {
      // Route for Office365 send connection
      const accountId = this.emailAccount.id || 0
      const officeIndexRoute = `/office365/${accountId}?token=${window.localStorage.session}&type=send`
      const route = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${officeIndexRoute}` : officeIndexRoute
      return route
    },
    receiveChannelOptions() {
      return [
        { text: "Office 365", value: "Office365Connector" },
        // { text: "Caseblocks", value: this.caseblocksConnectorValue, disabled: true },
        { text: "Other", value: "ImapConnector" }
      ]
    },
    sendChannelOptions() {
      return [
        { text: "Office 365", value: "Office365Connector" },
        // { text: "Caseblocks", value: this.caseblocksConnectorValue, disabled: true },
        { text: "Other", value: "SmtpConnector" }
      ]
    },
    receiveChannel: {
      get() {
        const channel = this.emailAccount.receiveChannel
        if (this.connectorAliases.includes(channel)) {
          return this.caseblocksConnectorValue
        }
        if (!channel) {
          if (this.hasCaseblocksMetadata) {
            return this.caseblocksConnectorValue
          }
          return "Office365Connector"
        }
        return channel
      },
      set(value) {
        const normalized = this.connectorAliases.includes(value) ? this.caseblocksConnectorValue : value
        this.$set(this.emailAccount, "receiveChannel", normalized)
      }
    },
    sendChannel: {
      get() {
        const channel = this.emailAccount.sendChannel
        if (this.connectorAliases.includes(channel)) {
          return this.caseblocksConnectorValue
        }
        if (!channel) {
          if (this.hasCaseblocksMetadata) {
            return this.caseblocksConnectorValue
          }
          return this.caseblocksConnectorValue
        }
        return channel
      },
      set(value) {
        const normalized = this.connectorAliases.includes(value) ? this.caseblocksConnectorValue : value
        this.$set(this.emailAccount, "sendChannel", normalized)
      }
    },
    isCaseblocksSelected() {
      return this.receiveChannel === this.caseblocksConnectorValue || this.sendChannel === this.caseblocksConnectorValue
    },
    isCaseblocksReceive() {
      return this.receiveChannel === this.caseblocksConnectorValue
    },
    isCaseblocksSend() {
      return this.sendChannel === this.caseblocksConnectorValue
    },
    hasMailgunDomain() {
      return !!(this.emailAccount.mailgunDomain && this.emailAccount.mailgunDomain.length)
    },
    isOffice365Connected() {
      // Check if Office365 is connected by looking at meta
      // If hasValidConnection is true, definitely connected
      // If emailAddress exists in meta, OAuth completed (even if validity check failed)
      if (!this.emailAccount.meta || !this.emailAccount.meta.office365) {
        return false
      }
      const office365 = this.emailAccount.meta.office365
      // Connected if hasValidConnection is true, or if emailAddress exists (OAuth completed)
      return office365.hasValidConnection === true || !!office365.emailAddress
    },
    isOffice365ReceiveConnected() {
      // Check if Office365 receive is connected
      if (!this.emailAccount.meta || !this.emailAccount.meta.office365) {
        return false
      }
      const office365 = this.emailAccount.meta.office365
      const receive = office365.receive || {}
      return receive.hasValidConnection === true || !!receive.emailAddress
    },
    isOffice365SendConnected() {
      // Check if Office365 send is connected
      if (!this.emailAccount.meta || !this.emailAccount.meta.office365) {
        return false
      }
      const office365 = this.emailAccount.meta.office365
      const send = office365.send || {}
      return send.hasValidConnection === true || !!send.emailAddress
    },
    canConnectOffice365Receive() {
      // Can connect if we have an email account ID
      return !!this.emailAccount.id
    },
    canConnectOffice365Send() {
      // Can connect if we have an email account ID
      return !!this.emailAccount.id
    },
    mailgunDomainStateLabel() {
      const state = this.emailAccount.mailgunDomainState
      if (!state) {
        return this.hasMailgunDomain ? "Provisioning" : "Not configured"
      }
      return state.charAt(0).toUpperCase() + state.slice(1)
    },
    shouldShowCaseblocksWarning() {
      const state = (this.emailAccount.mailgunDomainState || "").toLowerCase()
      return this.hasMailgunDomain && state && state !== "active"
    },
    canInvokeMailgunMutation() {
      return !!this.emailAccount.id
    },
    configureDomainDisabled() {
      return !this.canInvokeMailgunMutation || !this.mailgunDomainInput || this.mailgunActionLoading
    },
    recheckDisabled() {
      return !this.canInvokeMailgunMutation || this.mailgunActionLoading
    },
    derivedMailgunDomain() {
      const replyTo = this.emailAccount.smtpDetails && this.emailAccount.smtpDetails.replyToEmailAddress
      const smtpLogin = this.emailAccount.smtpDetails && this.emailAccount.smtpDetails.login
      const imapLogin = this.emailAccount.imapDetails && this.emailAccount.imapDetails.login
      return this.extractDomainFromEmail(replyTo) || this.extractDomainFromEmail(smtpLogin) || this.extractDomainFromEmail(imapLogin) || ""
    },
    sendingDnsRecords() {
      const records = this.emailAccount.mailgunDnsRecords
      if (!records) {
        return []
      }
      const scoped = []
      const addRecords = (list = [], scope) => {
        list.forEach((record, index) => {
          scoped.push({
            key: `${scope}-${record.type || "unknown"}-${record.name || index}`,
            type: record.type || "",
            name: record.name || "",
            value: record.value || "",
            priority: record.priority != null && record.priority !== "" ? record.priority : "N/A",
            valid: !!record.valid,
            description: record.description || (scope === "sending" ? "Sending" : "Receiving")
          })
        })
      }
      addRecords(records.sending, "sending")
      return scoped
    },
    receivingDnsRecords() {
      const records = this.emailAccount.mailgunDnsRecords
      if (!records) {
        return []
      }
      const scoped = []
      const addRecords = (list = [], scope) => {
        list.forEach((record, index) => {
          scoped.push({
            key: `${scope}-${record.type || "unknown"}-${record.name || index}`,
            type: record.type || "",
            name: record.name || "",
            value: record.value || "",
            priority: record.priority != null && record.priority !== "" ? record.priority : "N/A",
            valid: !!record.valid,
            description: record.description || (scope === "sending" ? "Sending" : "Receiving")
          })
        })
      }
      addRecords(records.receiving, "receiving")
      return scoped
    },
    formattedServerMessage() {
      if (!this.emailAccount.serverMessage) {
        return ""
      }

      const message = this.emailAccount.serverMessage

      // Try to parse and format timestamp if it exists
      // Format: [2025-11-04T12:30:00.000Z] Message text
      const timestampMatch = message.match(/^\[([\dTZ.:-]+)\]\s*(.+)$/)

      if (timestampMatch) {
        try {
          const timestamp = new Date(timestampMatch[1])
          const messageText = timestampMatch[2]

          // Format timestamp in a readable format
          const formattedDate = timestamp.toLocaleString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short'
          })

          return `[${formattedDate}] ${messageText}`
        } catch (e) {
          // If date parsing fails, return original message
          return message
        }
      }

      // Return message as-is if no timestamp format detected
      return message
    }
  },
  methods: {
    extractDomainFromEmail(value) {
      if (!value || typeof value !== "string") {
        return ""
      }
      const trimmed = value.trim()
      const atIndex = trimmed.indexOf("@")
      if (atIndex === -1) {
        return ""
      }
      return trimmed.slice(atIndex + 1)
    },
    resetMailgunDomainInput(forceUpdate) {
      if (this.mailgunActionLoading && !forceUpdate) {
        return
      }
      const suggestion = this.emailAccount.mailgunDomain || this.derivedMailgunDomain || ""
      if (forceUpdate || !this.mailgunDomainInput) {
        this.mailgunDomainInput = suggestion
      }
    },
    initializeOffice365Email() {
      // Initialize from meta if available - only use the authenticated email address
      if (this.emailAccount.meta && this.emailAccount.meta.office365) {
        const office365 = this.emailAccount.meta.office365
        // Initialize receive email address from authenticated email
        const receive = office365.receive || {}
        this.office365ReceiveEmailAddress = receive.emailAddress || ""
        // Initialize send email address from authenticated email
        const send = office365.send || {}
        this.office365SendEmailAddress = send.emailAddress || ""
      }
    },
    dirty() {
      this.isDirty = true
      this.$emit("has-changed", { index: this.index })
    },
    onReceiveChannelChange() {
      // Ensure the channel value is set on the emailAccount object
      this.$set(this.emailAccount, "receiveChannel", this.receiveChannel)
      this.dirty()
    },
    onSendChannelChange() {
      // Ensure the channel value is set on the emailAccount object
      this.$set(this.emailAccount, "sendChannel", this.sendChannel)
      this.dirty()
    },
    async refreshCaseblocksStatus() {
      await this.runMailgunSetup(undefined, "refresh")
    },
    async configureMailgunDomain() {
      const domain = (this.mailgunDomainInput || "").trim()
      if (!domain) {
        this.$store.commit("displayFlashMessage", { message: "Enter the domain you want Caseblocks to configure.", severity: "error" })
        return
      }
      await this.runMailgunSetup(domain, "configure")
    },
    async runMailgunSetup(domain, actionType) {
      if (!this.canInvokeMailgunMutation) {
        this.$store.commit("displayFlashMessage", { message: "Save this email account before configuring the Caseblocks domain.", severity: "error" })
        return
      }
      this.mailgunActionLoading = true
      this.mailgunActionType = actionType
      try {
        await this.$store.dispatch("setupMailgunDomain", {
          emailAccountId: this.emailAccount.id,
          domain: domain || undefined
        })
      } catch (error) {
        console.error("Failed to setup Mailgun domain", error)
      } finally {
        this.mailgunActionLoading = false
        this.mailgunActionType = null
      }
    },
    deleteEmailAccount(shouldRemove) {
      this.deleteDialog = false
      if (shouldRemove) {
        this.$store.dispatch("deleteEmailAccount", { emailAccount: this.emailAccount, index: this.index })
      }
    },
    showDeleteDialog() {
      this.deleteDialog = true
    },
    subscribeToEmailAccountUpdates() {
      if (!this.emailAccount || !this.emailAccount.id) {
        return
      }
      
      console.log("subscribeToEmailAccountUpdates", "Subscribing to Email Account Updates for account id", this.emailAccount.id)
      this.emailAccountSubscription = apollo.subscribe({
        query: gql(`
          subscription emailAccountUpdated($emailAccountId: Int!) {
            emailAccountUpdated(emailAccountId: $emailAccountId) {
              emailAccount {
                id
                name
                description
                isDefault
                sendChannel
                receiveChannel
                serverMessage
                hasMessage
                mailgunDomain
                mailgunDomainState
                mailgunDnsRecords
                meta
                imapDetails {
                  host
                  port
                  login
                  password
                  ssl
                  startTLS
                  enabled
                }
                smtpDetails {
                  host
                  port
                  login
                  password
                  ssl
                  startTLS
                  enabled
                  replyToEmailAddress
                }
              }
            }
          }
        `),
        variables: { emailAccountId: parseInt(this.emailAccount.id, 10) }
      }).subscribe({
        next: (response) => {
          console.log("emailAccountUpdated", "Received update", response)
          const updatedEmailAccount = response.data.emailAccountUpdated.emailAccount
          // Update the emailAccount prop using Vue.set for reactivity
          // Update nested properties to maintain reactivity
          if (updatedEmailAccount.meta) {
            this.$set(this.emailAccount, 'meta', updatedEmailAccount.meta)
            // Explicitly reinitialize Office365 email addresses after meta update
            this.$nextTick(() => {
              this.initializeOffice365Email()
            })
          }
          if (updatedEmailAccount.sendChannel) {
            this.$set(this.emailAccount, 'sendChannel', updatedEmailAccount.sendChannel)
          }
          if (updatedEmailAccount.receiveChannel) {
            this.$set(this.emailAccount, 'receiveChannel', updatedEmailAccount.receiveChannel)
          }
          // Update other properties that might have changed
          Object.keys(updatedEmailAccount).forEach(key => {
            if (key !== 'imapDetails' && key !== 'smtpDetails' && key !== 'meta') {
              this.$set(this.emailAccount, key, updatedEmailAccount[key])
            }
          })
        },
        error: (err) => {
          console.error("emailAccountUpdated", "Subscription error", err)
        },
        complete: () => {
          console.log("emailAccountUpdated", "Subscription completed")
        }
      })
    },
    unsubscribeFromEmailAccountUpdates() {
      if (this.emailAccountSubscription) {
        console.log("unsubscribeFromEmailAccountUpdates", "Unsubscribing from Email Account Updates")
        this.emailAccountSubscription.unsubscribe()
        this.emailAccountSubscription = null
      }
    },
    expand() {
      // Expand the panel by clicking the header
      this.$nextTick(() => {
        const panel = this.$el
        if (panel) {
          const header = panel.querySelector('.v-expansion-panel-header')
          if (header && !panel.querySelector('.v-expansion-panel-content--active')) {
            header.click()
          }
        }
      })
    }
  }
}
</script>


<style lang="scss" scoped>
.config-card-container {
  display: flex;
  flex-direction: row;
  gap: 20px;

  .config-card {
    flex: 1;
  }
}
@media (max-width: 1120px) {
  .config-card-container {
    flex-direction: column;
  }
}
</style>